import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "response-list" }
const _hoisted_3 = { class: "response-label" }
const _hoisted_4 = { class: "response-value" }

type ResponseItem = {
  label: string;
  value: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryDetailResponsesSection',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-header" }, [
      _createElementVNode("p", { class: "section-title" }, "Your Responses")
    ], -1)),
    _createVNode(_component_v_divider),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "response-row"
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(index + 1) + ". " + _toDisplayString(item.label), 1),
          _createElementVNode("p", _hoisted_4, "  " + _toDisplayString(item.value), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})